import React from 'react'
import { BCol, BTitle, BText, BRow, BSpinner } from '@prague-digi/ui-components'

import Notification from '../Notification/Notification'

interface Props {
  children: any
  subtitle: string
  warning: string
}

export const PrintLoader: React.FunctionComponent<Props> = (
  props: Props
): React.ReactElement<Props> => (
  <>
    <BTitle center type="h3">
      {props.children}
    </BTitle>
    <BText center>{props.subtitle}</BText>
    <BSpinner isShown isStatic style={{ zIndex: 0 }} />
    <BRow>
      <BCol theme="mt-3">
        <Notification type="warning" title={props.warning} />
      </BCol>
    </BRow>
  </>
)
